export default __webpack_public_path__ + "static/media/calendar.4150bd3d.png";